import React from 'react'
import { Box, Heading, useColorModeValue } from '@chakra-ui/react'

const SectionHeader = ({ title, subtitle }) => {
    const borderColor = useColorModeValue('gray.900', 'gray.100')
    const textColor = useColorModeValue('gray.900', 'gray.100')
    const textBgColor = useColorModeValue('brand.dayBgColor', 'brand.nightBgColor')

    return (
        <Box
            py={6}
            px={[2, 2, 4, 8, 12]}
            borderWidth={1}
            borderStyle={'solid'}
            borderColor={borderColor}
            borderX={0}
            pos={'relative'}
            mt={20}
            mb={10}
        >
            <Heading
                as={'h2'}
                size={'2xl'}
                fontWeight={'100'}
                pos={'absolute'}
                color={textColor}
                bg={textBgColor}
                px={6}
                top={0}
                m={0}
                transform={'translateY(-50%);'}
            >
                {title}
            </Heading>
            {subtitle && (
                <Heading className={'avrt'} as={'h3'} size={'md'} fontWeight={'400'} px={6} mt={6}>
                    {subtitle}
                </Heading>
            )}
        </Box>
    )
}

export default SectionHeader
